/* global appData */

import $ from 'jquery';

import template from './skyfish.vhtml';
import QdSkyfishMedia from '../skyfish-media/skyfish-media.js';
import { mixin as clickaway } from 'vue-clickaway';

export default {
	mixins: [clickaway],
	template: template,
	components: {
		QdSkyfishMedia,
	},
	props: {
		siteData: {
			type: Object,
			default: null,
		},
		postId: {
			type: Number,
			default: null,
		},
		lang: {
			type: String,
			default: '',
		}
	},
	data: () => ({
		media: [],
		filteredMedia: [],
		searchString: '',
		apiResult: null,
		loading: true,
		downloadFile: '',
		showTermsModal: false,
		termsConsent: false,
	}),
	computed: {
		searchPlaceholder() {
			return this.$t('searchMedia') + '...';
		},
		dowloadFolderUrl() {
			return this.postId !== null > 0 ? `${appData.root}cp/v1/page-gallery/${this.postId}/download` : null;
		},
	},
	watch: {
		searchString() {
			const searchString = this.searchString.toLowerCase();
			if ( this.searchString.length !== 0 ) {
				this.filteredMedia = this.media.filter( el => {
					const title = el.title.toLowerCase();
					let keywords = el.keywords.filter( word => word.toLowerCase().includes(searchString));
					return title.includes(searchString) || keywords.length > 0;
				});
			} else {
				this.filteredMedia = this.media;
			}
		},
	},
	methods: {
		getPostGallery() {
			console.log('Fetching');

			const endpoint = `${appData.root}cp/v1/page-gallery/${this.postId}`;

			return $.get(endpoint)
				.then( content => this.apiResult = content )
				.then(() => this.media = this.apiResult.status === 200 ? this.media.concat(this.apiResult.data.media) : this.media )
				.then(() => this.filteredMedia = this.filteredMedia.concat(this.media) )
				.then(() => this.loading = false );
		},
		showModal(file) {
			this.showTermsModal = true;
			this.downloadFile = file;
		},
		closeModal() {
			this.showTermsModal = false;
		},
		acceptTerms() {
			localStorage.termsConsent = true;
			this.termsConsent = true;
			this.showTermsModal = false;
			window.open(this.downloadFile, '_self');
		},
		downloadMedia(file) {
			if (this.lang == 'da') {
				if (this.siteData.website_dl_terms_toggle && this.siteData.website_download_terms_da && this.siteData.website_download_terms_da != '') {
					if (localStorage.termsConsent) {
						window.open(file, '_self');
					} else {
						this.showModal(file);
					}
				} else {
					window.open(file, '_self');
				}
			} else if (this.lang == 'en') {
				if (this.siteData.website_dl_terms_toggle && this.siteData.website_download_terms_en && this.siteData.website_download_terms_en != '') {
					if (localStorage.termsConsent) {
						window.open(file, '_self');
					} else {
						this.showModal(file);
					}
				} else {
					window.open(file, '_self');
				}
			} else if (this.lang == 'de') {
				if (this.siteData.website_dl_terms_toggle && this.siteData.website_download_terms_de && this.siteData.website_download_terms_de != '') {
					if (localStorage.termsConsent) {
						window.open(file, '_self');
					} else {
						this.showModal(file);
					}
				} else {
					window.open(file, '_self');
				}
			}
		}
	},
	mounted() {
		if (localStorage.termsConsent) {
			this.termsConsent = true;
		} else {
			this.termsConsent = false;
		}

		// Fetch the gallery
		this.getPostGallery();
	}
};


// WEBPACK FOOTER //
// ./assets/_js/components/skyfish/skyfish.js